import * as React from 'react';
import { cloneDeep } from 'lodash';

import { IDocument, IUserData } from '../../../../infrastructure/interfaces';
import SettingsNav from './SettingsNav';
import CompanyInfoEditorForm from '../../../DocumentEditor/CompanyInfoEditorForm';

export interface ICompanyInfoEditorProps {
  document: IDocument;
  userData: IUserData;
  updateDocument(document: IDocument, userID: string): void;
  updateModelDocument?(document: IDocument): void;
  cancelDocument?(): void;
}

export interface ICompanyInfoEditorState {
  document: IDocument;
}
export default class CompanyInfoEditor extends React.Component<ICompanyInfoEditorProps, ICompanyInfoEditorState> {
  constructor(props: ICompanyInfoEditorProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: ICompanyInfoEditorProps) {
    if (nextProps.document !== this.props.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  onFieldChange = (field: string, value: string | boolean) => {
    this.setState({
      document: {
        ...this.state.document,
        companyInfo: {
          ...this.state.document.companyInfo,
          [field]: value,
        },
      },
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  onSave = () => {
    this.props.updateDocument(this.state.document, this.props.userData.id);
  }

  render() {
    return (
      <div className="cropsEditorContainer">
        <SettingsNav
          cancel={this.cancel}
          document={this.state.document}
          onSave={this.onSave}
        />
        <div className="">
          <div className="cropsContainerTitle">
            Company Information:
              <span>Please enter required company information. Your order cannot be submitted without it.</span>
          </div>
        </div>
        <CompanyInfoEditorForm
          onFieldChange={this.onFieldChange}
          document={this.state.document}
          contClassName="settingsCropsListContainer"
        />
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/CompanyInfoEditor.tsx